module.exports = __webpack_public_path__ + "static/fe7e0069510a90ab5de7b61f030e28dd6edcf124c779b5d63631655191aa78cc-f411d87c6dd28b8f506f79b0a851420a.png";